import React, { Suspense } from 'react';
import {
    type PhoneInputSmartProps,
    type CountryCode
} from '@avtopro/telephone-input-smart';
import TextInput from '@avtopro/text-input';
import globals from 'Js/common/globals';

/**
 * Обёртка для "ленивой" подгрузки компонента @avtopro/telephone-input-smart,
 * который валидирует номер телефона при помощи библиотеки libphonenumber-js.
 *
 * Подключается по алиасу "@avtopro/telephone-input-smart/lazy".
 *
 * Помимо оптимизации, компонент отвечает за предварительную настройку компонента:
 *
 *  [defaultCountry]    - определяется на основе геолокации пользователя.
 *
 *  [restrictCountries] - по умолчанию меняется на true, это значение больше подходит
 *                        для Автопро, потому что в большинстве случаев страна покупателя и продавца
 *                        соответствует настройкам площадки и не может выбираться произвольно.
 */
const PhoneInputSmartButLazy = React.lazy(
    () => import(/* webpackMode: "eager" */ '@avtopro/telephone-input-smart')
);

const PhoneInputSmart = ({
    restrictCountries,
    allowedCountries,
    defaultCountry,
    defaultValue,
    blockSize,
    ...otherProps
}: PhoneInputSmartProps) => {
    const { CountryISO: geoLocationCountry } = globals.geoLocation ?? {};
    const { countries: siteCountries } = globals.site as {
        countries: CountryCode[];
    };
    return (
        <Suspense
            fallback={
                <TextInput
                    defaultValue={defaultValue}
                    blockSize={blockSize}
                    disabled
                />
            }
        >
            <PhoneInputSmartButLazy
                restrictCountries={restrictCountries ?? true}
                allowedCountries={allowedCountries ?? siteCountries}
                defaultCountry={defaultCountry ?? geoLocationCountry}
                defaultValue={defaultValue}
                blockSize={blockSize}
                {...otherProps}
            />
        </Suspense>
    );
};

export default PhoneInputSmart;
